import { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import ProfilePicture from './ProfilePicture';
import Loading from './Loading';
import { displaySpeakerName, getDisplaySpeakerData, shouldShowTranscriptSpeaker } from './speakerHelper';

const MessageTranscript = ({ messageId, messageSelected }) => {
    const containerRef = useRef(null);
    const [loading, setLoading] = useState(true);
    const [speakers, setSpeakers] = useState(null);
    const [transcript, setTranscript] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        let active = true;
        const controller = new AbortController();
        let scrollTimer;
        setLoading(true);
        setErrorMessage(null);
        axios.get(`/message_transcript/${messageId}`, { signal: controller.signal })
            .then(response => {
                if (!active) return;
                setTranscript(response.data.transcript);
                setSpeakers(response.data.speakers);
                setLoading(false);
                scrollTimer = window.setTimeout(() => {
                    containerRef.current?.querySelector('[data-selected="true"]')
                        ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 200);
            })
            .catch(() => {
                if (!active) return;
                setErrorMessage('Couldn’t load the transcript. Please reopen it to try again.');
                setLoading(false);
            });
        return () => {
            active = false;
            controller.abort();
            window.clearTimeout(scrollTimer);
        };
    }, [messageId]);

    const getSpeaker = (message) => getDisplaySpeakerData(
        message.speakerId, speakers, message.anonymousDisplay,
    );

    const getMessageText = (message) => message.message.map(word => word.text).join('');

    const selectedMessage = (message) => () => {
        if (messageSelected) {
            const speaker = getSpeaker(message);
            messageSelected(message, speaker);
        }
    }

    return (
        <div ref={containerRef}>
            {loading ? <Loading /> : (
                <div>
                    {errorMessage ? (
                        <div role='alert' style={{ padding: '20px', textAlign: 'center' }}>
                            {errorMessage}
                        </div>
                    ) : (
                        <div style={{ padding: '0px 20px 20px' }}>
                            {transcript && speakers ? transcript.map((message, index) => {
                                const showSpeaker = shouldShowTranscriptSpeaker(index, transcript);
                                const speaker = getSpeaker(message);
                                return (
                                    <div key={index} style={{ marginBottom: '12px' }}>
                                        {showSpeaker ? (
                                            <div style={{ display: 'flex', alignItems: 'center', margin: '24px 0px 12px' }}>
                                                <ProfilePicture
                                                    speakerId={speaker.id}
                                                    borderSize={1}
                                                    imageSrc={speaker.imageURL}
                                                    anonymousDisplay={speaker.anonymousDisplay}
                                                    size='36px'
                                                    margin='0px 8px 0px 0px' />
                                                <div className='speakerNameSmall'>
                                                    {displaySpeakerName(speaker)}
                                                </div>
                                            </div>
                                        ) : null}
                                        <div>
                                            {messageSelected ?
                                                <button onClick={selectedMessage(message)} id={'messageTranscript' + message.id} className='notesContextMessage' data-selected={message.id === messageId} style={{ textAlign: 'left', padding: '12px 16px', background: message.id === messageId ? 'var(--app-highlight)' : 'var(--app-surface)', borderRadius: '10px', fontSize: '16px' }}>
                                                    {getMessageText(message)}
                                                </button>
                                                :
                                                <div id={'messageTranscript' + message.id} className='notesContextMessage' data-selected={message.id === messageId} style={{ background: message.id === messageId ? 'var(--app-highlight)' : 'var(--app-background)', fontSize: '16px' }}>
                                                    {getMessageText(message)}
                                                </div>
                                            }
                                            
                                        </div>
                                    </div>
                                )
                            }) : null}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default MessageTranscript;
